import { computed, inject, Injectable } from '@angular/core';
import { BuilderService } from './builder.service';
import { SectionStructureObject } from '../../api/interfaces';

@Injectable()
export class DragDropService {
  private readonly builderService = inject(BuilderService);

  readonly sectionList = computed(() => {
    return this.builderService.moduleStructure()?.root.children || [];
  });

  readonly subSectionList = computed(() => {
    const sectionIds =
      this.builderService.moduleStructure()?.root.children || [];
    let subsectionIds: string[] = [];
    sectionIds.forEach((sectionId) => {
      const section = this.builderService.moduleStructure()[
        sectionId
      ] as SectionStructureObject;
      subsectionIds = [...subsectionIds, ...section.children];
    });

    return subsectionIds;
  });
}
